import { request } from '@/utils/request';

export function getDataSetList(data: any) {
  const { path = '' } = data;
  return request({
    url: `/cdh/data/set/getList${path}`,
    method: 'post',
    data,
  });
}

export function getOptions() {
  return request({
    url: '/cdh/data/set/getOptions',
    method: 'get',
  });
}
export function getTagAdd(data: any) {
  return request({
    url: '/cdh/data/set/getTagAdd',
    method: 'get',
    params: data,
  });
}
export function postTagSave(data: any) {
  return request({
    url: '/cdh/data/set/tagSave',
    method: 'post',
    data,
  });
}
export function postTagEdit(data: any) {
  return request({
    url: '/cdh/data/set/tagEdit',
    method: 'post',
    data,
  });
}

export function getTagEdit(data: any) {
  return request({
    url: '/cdh/data/set/getTagEdit',
    method: 'get',
    params: data,
  });
}

/**
 *
 * feature Data Set
 */
export function getfutureDataList(data: any) {
  const { path } = data;
  return request({
    url: `/cdh/data/futureData/getList${path}`,
    method: 'post',
    data,
    serverless: true,
  });
}
export function getfuturegetOptions() {
  return request({
    url: '/cdh/data/futureData/getOptions',
    method: 'get',
    serverless: true,
  });
}
export function postfuturecreateDate(data: any) {
  return request({
    url: '/cdh/data/futureData/createData',
    method: 'post',
    data,
    serverless: true,
  });
}
export function postfutureoperationShow(data: any) {
  return request({
    url: '/cdh/data/futureData/operationShow',
    method: 'get',
    params: data,
    serverless: true,
  });
}
export function getfutureDbo() {
  return request({
    url: '/cdh/data/futureData/getDbo',
    method: 'get',
    serverless: true,
  });
}

export function getfuturegetTag(data: any) {
  return request({
    url: '/cdh/data/futureData/getTagAdd',
    method: 'post',
    data,
    serverless: true,
  });
}
export function postEditState(data: any) {
  return request({
    url: '/cdh/data/futureData/editState',
    method: 'post',
    data,
    serverless: true,
  });
}

export function getDataSetDetailsInfo(data: any) {
  return request({
    url: '/cdh/data/set/getDetailsInfo',
    method: 'get',
    params: data,
  });
}

export function getOverviewData(data: any) {
  return request({
    url: '/cdh/data/set/getOverviewData',
    method: 'post',
    data,
  });
}
export function getOverviewData4Chart(data: any) {
  return request({
    url: '/cdh/data/set/getOverviewData4Chart',
    method: 'post',
    data,
  });
}
export function getConsumers(data: any) {
  return request({
    url: '/cdh/data/set/getConsumers',
    method: 'get',
    params: data,
  });
}

export function getDatasetHistory(data: any) {
  return request({
    url: `/cdh/data/set/history/${data}`,
    method: 'get',
  });
}

export function getDatasetDetail(params: any) {
  return request({
    url: `/cdh/data/futureData/getDetail`,
    method: 'get',
    params,
    serverless: true,
  });
}
/**
 *
 * Data Set Premiss
 */
export function getCdhDatasetPermissionList(data: any) {
  return request({
    url: '/data/dataQuality/getCdhDatasetPermissionList',
    method: 'post',
    data,
  });
}
export function updateDatasetPermission(data: any) {
  return request({
    url: '/data/dataQuality/datasetPermission/updateStatus',
    method: 'get',
    params: data,
  });
}

export function getCheckList(id: string) {
  return request({
    url: `/dataAsset/dod/checkList/list/${id}`,
    method: 'get',
  });
}
export function getCheckListByWorkSpace(id: string) {
  return request({
    url: `/dataAsset/dod/checkList/myWorkspace/list/${id}`,
    method: 'get',
  });
}

export function fetchCheckUpdate(data: any) {
  return request({
    url: `/dataAsset/dod/checkList/myWorkspace/update`,
    method: 'post',
    data,
  });
}
